// Interfaces
import { IBaseEmptyProps } from './interfaces'

// Antd
import { Empty } from 'antd'

// I18n
import { useTranslation } from 'react-i18next'

// Lodash
import omit from 'lodash/omit'

const BaseEmpty = (props: IBaseEmptyProps) => {
  // Hook
  const { t } = useTranslation()

  return (
    <div className="flex items-center justify-center my-12">
      <Empty
        {...omit(props, ['isWhiteText'])}
        description={<p className={`${props?.isWhiteText ? 'text-white' : ''}`}>{props?.description || t('app.noContent')}</p>}
      />
    </div>
  )
}
export { BaseEmpty }
